/**
 * @file
 * Controls the expandable account menu.
 */

(function (Drupal, once) {
  Drupal.behaviors.accountMenu = {
    attach(context) {
      once('account-menu', '.account-menu__toggle', context).forEach((toggle) => {
        const contentId = toggle.getAttribute('aria-controls');
        const content = document.getElementById(contentId);

        if (!content) {
          return;
        }

        const openMenu = () => {
          toggle.closest('.site-header').dispatchEvent(
            new CustomEvent('adocs:header-panel-open', { detail: toggle })
          );
          content.inert = false;
          content.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          toggle.closest('.account-menu')?.classList.add('is-open');
        };

        const closeMenu = () => {
          if (content.contains(document.activeElement)) {
            toggle.focus({ preventScroll: true });
          }
          content.inert = true;
          content.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          toggle.closest('.account-menu')?.classList.remove('is-open');
        };

        toggle.closest('.site-header').addEventListener('adocs:header-panel-open', (event) => {
          if (event.detail !== toggle) closeMenu();
        });

        toggle.addEventListener('click', () => {
          const isOpen = toggle.getAttribute('aria-expanded') === 'true';

          if (isOpen) {
            closeMenu();
          }
          else {
            openMenu();
          }
        });

        document.addEventListener('click', (event) => {
          if (
            !toggle.contains(event.target) &&
            !content.contains(event.target)
          ) {
            closeMenu();
          }
        });

        document.addEventListener('keydown', (event) => {
          if (
            event.key === 'Escape' &&
            toggle.getAttribute('aria-expanded') === 'true'
          ) {
            closeMenu();
            toggle.focus();
          }
        });
      });
    },
  };
})(Drupal, once);
